import core from "@/core/index";
import store from "@/store";

class FacilityVideoService {
  getList(facilityId) {
    return new Promise(async (resolve, reject) => {
      core.http
        .getJson(`/api/facility/${facilityId}/video`, { ignoreAlertModal: true })
        .then((data) => {
          if (data.videoList) {
            const videoList = data.videoList;
            resolve(videoList);
          } else {
            reject({
              message: "not found item",
            });
          }
        })
        .catch((reason) => {
          //console.log('error: ', reason);
          reject(reason);
        });
    });
  }

  create(facilityId, params) {
    const strParam = JSON.stringify(params);
    return new Promise((resolve, reject) => {
      core.http
        .postJson(`/api/facility/${facilityId}/video`, strParam)
        .then((data) => {
          if (data.video) {
            resolve(data.video);
          } else {
            reject({
              message: "not found item",
            });
          }
        })
        .catch((reason) => {
          //console.log('error: ', reason);
          reject(reason);
        });
    });
  }

  update(facilityId, videoId, params) {
    const strParam = JSON.stringify(params);
    return new Promise((resolve, reject) => {
      core.http
        .putJson(`/api/facility/${facilityId}/video/${videoId}`, strParam)
        .then((data) => {
          if (data.video) {
            resolve(data.video);
          } else {
            reject({
              message: "not found item",
            });
          }
        })
        .catch((reason) => {
          //console.log('error: ', reason);
          reject(reason);
        });
    });
  }

  delete(facilityId, videoId) {
    return new Promise((resolve, reject) => {
      core.http
        .delete(`/api/facility/${facilityId}/video/${videoId}`)
        .then((data) => {
          resolve(data);
        })
        .catch((reason) => {
          //console.log('error: ', reason);
          reject(reason);
        });
    });
  }
}

export default new FacilityVideoService();
